import {createAction} from '@ngrx/store';

export const saveToLocalStorage = createAction('saveToLocalStorage');
export const loadFromLocalStorage = createAction('loadFromLocalStorage');
